// code d'erreur du WAF Cloudflare lorsqu'il détecte trop de requêtes
export const FORBIDDEN_STATUS_CODE = 403
export const TOO_MANY_REQUEST_STATUS_CODE = 429
